
import axios from "../network/reuset"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块

const getPayouts = {
  getPayoutsList(params) {
    return axios.post(
      `/api/admin/payouts/list`,
      qs.stringify(params)
    );
  },
  getPayoutsInfo(params) {
    return axios.post(
      `/api/admin/payouts/info`,
      qs.stringify(params)
    );
  },
  saveCheckPayouts(params) {
    return axios.post(
      `/api/admin/payouts/check`,
      qs.stringify(params)
    );
  },
  postAddPayouts(params) {
    return axios.post(
      `/api/admin/payouts/add`,
      qs.stringify(params)
    );
  },
  getMoneyList(params) {
    return axios.post(
      `/api/admin/payouts_money/list`,
      qs.stringify(params)
    );
  },
  postSaveMoney(params) {
    return axios.post(
      `/api/admin/payouts_money/save`,
      qs.stringify(params)
    );
  },
  postAddMoney(params) {
    return axios.post(
      `/api/admin/payouts_money/add`,
      qs.stringify(params)
    );
  },
  delMoney(params) {
    return axios.post(
      `/api/admin/payouts_money/del`,
      qs.stringify(params)
    );
  },
};
export default getPayouts;
